<script>
import InvoicesApi from "@/services/invoices-api";
import ItemsApi from "@/services/items-api";
import CustomersApi from "@/services/customers-api";
import ReportingApi from "@/services/reporting-api";
import CatalogSearchSuggestions from "@/components/CatalogSearchSuggestions";
import { debounce } from "lodash";


export default {
  components: { CatalogSearchSuggestions },
      props: {
      
        api:{
          type:Function,
          default: null
        },

      },
    computed:{
      role() {
        return this.$cookies.get('userr') ? this.$cookies.get('userr') : 0;
      },

      customerCategory(){
        return this.$cookies.get('custCat');
      },

      // same switch as the catalogue suggestions: instances with Saisie rapide
      isItemSuggestionsEnabled(){
        return process.env.VUE_APP_FEATURE_QUICK_ORDER === 'true';
      },

    },
    created(){
      this.debouncedFindItems = debounce(() => { this.pagemodelMain.currentPage = 1; this.findItems() }, 350);
    },
    mounted(){
      this.getCustomers();
      // PARA only for a known Para customer (category 1), PHARMA otherwise (suppliers, unknown category)
      this.selectedType = this.customerCategory == 1 ? this.typesOptions[1] : this.typesOptions[0]
    },

    data (){
        return {
            customersList:[],
           // selectedCustomer : null,
            selected:null,
            delivredItems:[],
            pagemodelMain: {currentPage : 1, perPage : 10, totalRows: 0},
            pagemodel: {currentPage : 1, perPage : 10000, totalRows: 0},
            isItemsTableBusy: false,

            isTableLoading:false,
             tableFields: [
              { key:"blNumber", label: "N° Document", thClass:"align-middle text-left", tdClass:"text-left font-weight-bold  align-middle "},
              { key:"blDate", label: "Date Document", thClass:"align-middle text-left", tdClass:"text-left font-weight-bold align-middle"},
              { key:"itemCode", label: "Code Article",thClass:"align-middle text-left", tdClass:"align-middle text-left"},
              { key:"itemTitle", label: "Article",thClass:"align-middle text-left", tdClass:"align-middle text-left"},
              { key:"batchNumber", label: "N° Lot",thClass:"align-middle text-left", tdClass:"align-middle text-left"},
              { key:"purchasesDate", label: "Date de Péremption",thClass:"align-middle", tdClass:"align-middle" },
              { key:"itemPrice", label: "Prix Article",thClass:"align-middle text-right", tdClass:"align-middle text-right"},

              { key:"itemQuantity", label: "Qte",thClass:"align-middle text-right", tdClass:"align-middle text-right"},
              { key:"orderQuantity", label: "Qte Offre ",thClass:"align-middle text-right", tdClass:"align-middle text-right"},
              { key:"totalPrice", label: "Total TTC",thClass:"align-middle text-right", tdClass:"align-middle text-right"},
              { key:"action", label: "Télécharger",thClass:"align-middle text-right", tdClass:"align-middle text-right"},

             

              ],
              itemFields: [
        { key:"title", label: "Article", sortable: true, tdClass:"p-0"},
        { key:"ref", label: "Réference", sortable: false, tdClass:"p-0"},
        { key:"price", label: "P.U (TND)", sortable: false, tdClass:"text-right font-weight-bold", thClass:"text-right", thStyle:"width:150px"},
        { key:"discount", label: "remise (TND)", sortable: false, tdClass:"text-right font-weight-bold", thClass:"text-right", thStyle:"width:150px"},
        { key:"discountedPrice", label: "P.U.Remisé (TND)", sortable: false, tdClass:"text-right font-weight-bold", thClass:"text-right", thStyle:"width:100px"},
        {key:"actions", label:"", thClass:"text-right", tdClass:"text-right"},
      ],

              avoirDetails: {},
              isNew: false ,

              selectedType : null,
              typesOptions : [{value:'PHARMA', text:"Articles Pharmaceutiques"}, {value:'PARA', text:"Articles Para-Pharmaceutiques"}],

              itemRef: null,
              // typed text of the article field when the suggestions are on
              itemSearch: "",
              // false once the server answered without /delivered-Item/items: then the catalogue search is used
              isItemLookupAvailable: true,
              isItemModalOpening: false,
              isDownloadInProgress: false,
              showItemModal: false ,
              itemLines:null,
              itemsFilter:null,

        }
    },

    watch:{
        selectedType : function (){
            this.getDeliveredItemByCustomer();
        }
    },

    methods: {
      getCustomers(){
        if(this.role == 0){
          return ;
        }
        CustomersApi.getCustomers(null,null).then(
          response => {
            if(response && response.length > 0){
              this.customersList=response;
              if(this.role == 1){
                this.selected = this.customersList[0]
                //this.selectedCustomer = this.customersList[0].id
              }
            }
          }
        )
      },

      selectedItem(item){
        this.itemRef =item.ref;
        this.itemSearch = item.ref;
        this.showItemModal= false ;
        // Para / Pharma filter follows the picked article (the user can still change it); a change of filter
        // already reloads the movements through the selectedType watcher
        const type = item.type === 'Para' ? 'PARA' : item.type === 'Pharma' ? 'PHARMA' : null
        const option = type && this.typesOptions.find(o => o.value === type)
        if (option && option !== this.selectedType) {
          this.selectedType = option
          return
        }
        this.getDeliveredItemByCustomer()
      },

      // suggestions of the article field: identification only (/delivered-Item/items), catalogue search on older servers
      lookupMovementItems(text){
        const catalogSearch = () => ItemsApi.findItems(1, 6, [], text,
          null, null, false, null, null, null, null, null, null,
          null, false, false, false, false, false, false, false,
          new Date().getTime()).then(result => (result && result.list) || [])
        if (!this.isItemLookupAvailable) return catalogSearch()
        return ReportingApi.findMovementItems(text, 6).then(list => {
          if (list) return list
          this.isItemLookupAvailable = false
          return catalogSearch()
        })
      },
        
      findItems() {
      
        this.isItemsTableBusy = true;
        this.itemsListTimestamp = new Date().getTime();
        ItemsApi.findItems(this.pagemodelMain.currentPage, this.pagemodelMain.perPage, 
                  [], 
                  this.itemsFilter, 
                  null, null, false, null, null,null,null, null, null,
                  null, false,false,false,false,false,false,false,
                  this.itemsListTimestamp
                  )
  
        .then(itemsList => {
      
          this.itemLines=itemsList.list ;
          this.pagemodelMain.totalRows = itemsList.total;
          this.pagemodelMain.currentPage = itemsList.page;
          this.pagemodelMain.perPage = itemsList.pageSize;
          this.pagemodelMain.pageSize = itemsList.pageSize;
        })
        .finally(() => {
          this.isItemsTableBusy = false;
          this.endOfFindItems = true;
        });
      },


      // Enter in the article field without a highlighted suggestion: the article list, filtered by the typed text
      openItemModalWithSearch(){
        this.itemsFilter = this.itemSearch || ""
        this.pagemodelMain.currentPage = 1
        this.showItemModal = true
        this.findItems()
      },

      // instances without Saisie rapide: typing in the article field opens the article list with what was typed,
      // and the typing goes on in the list's own search field
      onItemFieldTyped(text){
        // keys typed while the list is still opening land here too: they follow into the list's filter
        if (this.isItemModalOpening) {
          this.itemsFilter = text
          this.debouncedFindItems()
          return
        }
        if (this.showItemModal || !text || !text.trim()) return
        this.isItemModalOpening = true
        this.itemsFilter = text
        this.showItemModal = true
        this.debouncedFindItems()
      },

      // the list's search field: focused when the list opens, cursor after the text, results while typing
      onItemModalShown(){
        if (this.isItemModalOpening) {
          this.isItemModalOpening = false
          this.itemSearch = this.itemRef || ""
        }
        const input = this.$refs.itemModalSearch && this.$refs.itemModalSearch.$el
        if (input) {
          input.focus()
          const end = (input.value || "").length
          input.setSelectionRange && input.setSelectionRange(end, end)
        }
      },

      onItemModalFilterTyped(){
        this.debouncedFindItems()
      },

      openItemModal(){
        this.itemsFilter= ""
        this.showItemModal= true ;
        this.findItems()
      },

      download(bl){
        this.isDownloadInProgress=true;
        InvoicesApi.downloadBLByDocNumber(bl.blNumber , this.selectedType.value , 1, this.selected.id)
        .finally(() => {
          this.isDownloadInProgress = false;
          this.getInvoices()
        })
      },
    
      getDeliveredItemByCustomer() {
        if(!this.itemRef){
            return;
        }

        this.isTableLoading = true;

        if (!this.selectedType) {
          this.selectedType = this.typesOptions[0];
        }

        this.api(this.selectedType ? this.selectedType.value : this.typesOptions[0].value,this.itemRef,this.selected ? this.selected.id : null)
          .then(result => {
            this.delivredItems = result
          
          })
          .finally(() => {
            this.isTableLoading = false;
          })
      },

    }, 

};
</script>
<template>
<div class="pt-5">
 <div v-if="role != 0 " class="row">
    <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3">
      <b-form-group :label="$t('lists.customers.filter')" label-for="">
        <v-select class="style-vselect-big" style="font-size:1.2em;" :options="customersList" :placeholder="$t('lists.customers.label')" label="fullCompanyName" v-model="selected">
          <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
        </v-select>
      </b-form-group>
    </div>
  </div>

  <div class="row ">
    <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3">
      <b-form-group   class="text-primary text-uppercase font-weight-bold font-size-14" label="Chercher Des mouvements par référence d'article"  >
        <!-- instances with Saisie rapide: type and pick from the suggestions (the button still opens the article list) -->
        <div v-if="isItemSuggestionsEnabled" class="position-relative">
          <b-input-group>
              <b-form-input id="movement-item-search-input" placeholder="Rechercher par référence ou désignation" autocomplete="off"
                v-model="itemSearch" @keyup.native.enter="openItemModalWithSearch()" ></b-form-input>
              <template v-slot:append>
                  <b-button variant="primary" @click="openItemModal()" >
                  <i class="bx bx-search-alt font-weight-bold font-size-16 text-white align-middle"></i>
                  </b-button>
              </template>
          </b-input-group>
          <CatalogSearchSuggestions :query="itemSearch" input-id="movement-item-search-input" :lookup="lookupMovementItems"
            details="ref-barcode" @pick="selectedItem" />
        </div>
        <!-- other instances: typing opens the article list with the typed text (the button still opens it empty) -->
        <b-input-group v-else  >
            <b-form-input  placeholder="Rechercher par référence ou désignation" autocomplete="off"
              v-model="itemSearch" @input="onItemFieldTyped" @focus.native="$event.target.select()" ></b-form-input>                              
            <template v-slot:append>
                <b-button variant="primary" @click="openItemModal()" >
                <i class="bx bx-search-alt font-weight-bold font-size-16 text-white align-middle"></i>
                </b-button>
            </template>
        </b-input-group>
    </b-form-group>
    </div>
  </div>

  <div class="row pb-5">
    <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3">
        <v-select class="style-vselect-big font-weight-bold" style="font-size:1.2em;" :options="typesOptions" label="text" v-model="selectedType">
              <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
        </v-select>
    </div>

  </div>

     

      <div class="table-responsive mt-4" style="min-height:30em;">   
        <b-table 
        :busy="isTableLoading"
        :striped="true"
        :small="false"
        :hover="true"
        :items="delivredItems"
        :perPage="pagemodel.perPage"
        :fields="tableFields"
        class="table  "
        >
        <template v-slot:table-busy>
          <div class="text-center my-2">
              <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
          </div>
        </template>

        <template v-slot:cell(action)="{item}"> 
          <b-button title="Télécharger"  size="sm"   variant="outline-secondary" href="javascript:void(0);" @click="download(item, 4)" :disabled="isDownloadInProgress">
                <i class="far fa-file-alt  font-size-16 align-middle mr-0 mr-xl-2"></i>
                <span class="d-none font-weight-bold d-xl-inline">Télécharger</span>
          </b-button> 
      </template>
        </b-table>
        <span v-if="!isTableLoading && delivredItems && !delivredItems.length" class="d-flex justify-content-center m-4 text-danger" >{{$t("invoicesMenu.list.empty")}}</span>
    </div>



    <!--      item modal
 -->    
 <b-modal v-model="showItemModal" @shown="onItemModalShown" @hidden="isItemModalOpening = false" 
      title="Liste des Articles" 
      centered  hide-footer
      title-tag="h5"
      header-close-variant="danger"
      title-class="text-warning"
      size="xl">
        <div class=" zoom-container">
            <div class="row pt-5">
    <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3">
      <b-form-group class="text-primary text-uppercase font-weight-bold font-size-14" label="Chercher Des mouvements par nom d'article" >
        <b-input-group  >
            <b-form-input ref="itemModalSearch" placeholder="Rechercher par référence ou désignation" @keyup.native.enter="findItems()"
              @input="onItemModalFilterTyped"
              v-model="itemsFilter" ></b-form-input>                              
            <template v-slot:append>
                <b-button variant="primary" @click="findItems()" >
                <i class="bx bx-search-alt font-weight-bold font-size-16 text-white align-middle"></i>
                </b-button>
            </template>
        </b-input-group>
    </b-form-group>
    </div>
  </div>
          <div class="col">
          <b-table
            :striped="true"
            :small="true"
            :hover="true"
            :items="itemLines"
            :fields="itemFields"
            sortKey="itemTitle"
            responsive
            class="col-12 p-3"
          > 
          <template v-slot:cell(actions)="{item}">
              <b-button size="sm" variant="primary" @click="selectedItem(item)" :class="item.id ? '' : 'd-none'" title="Sélectionner">
                <i class="fas fa-search font-size-14 mr-1"></i>
                <span>Sélectionner</span>
              </b-button>
        </template>
                             
        </b-table>
        <!--Pagination-->         
            <div class="col-12">
                  <div class="row">
                    <div class="col-8">
                        <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                            <b-form-select @input="findItems()"  v-model="pagemodelMain.perPage" size="sm" style="width: 60px" :options="[10,15,50,100]"></b-form-select>
                            <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">sur</span><span class="font-weight-bold"> {{pagemodelMain.totalRows}} lignes</span></div>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="dataTables_paginate paging_simple_numbers float-right">
                            <ul class="pagination pagination-rounded mb-0">
                            <b-pagination v-model="pagemodelMain.currentPage" :disabled="isItemsTableBusy" :per-page="pagemodelMain.pageSize" :total-rows="pagemodelMain.totalRows" @input="findItems()" ></b-pagination>
                            </ul>
                        </div>
                    </div>
                  </div>
              </div> 
          <!--Fin Pagination-->         
        </div>

      </div>

        <template v-slot:modal-footer>
          <b-button class="zoom-container" variant="secondary"  size="md">Annuler</b-button>
        </template>
      </b-modal>

</div>
</template>                                                                                                                                                                                                                                                                                                                  